import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'projet/:id',
    loadComponent: () =>
      import('./components/project-detail/project-detail.component').then(
        (m) => m.ProjectDetailComponent
      ),
  },
  {
    path: 'motion-design',
    loadComponent: () =>
      import('./components/motion-design/motion-design.component').then(
        (m) => m.MotionDesignComponent
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./home.component').then((m) => m.HomeComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
